import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginFormService } from './login-form.service';
import { SearchObjectService, SearchObject } from '../../../../shared/services/search-object.service';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';
import { LoadingScreenService } from 'src/app/shared/components/loading-screen/loading-screen.service';
import { MatDialog } from '@angular/material/dialog';
import { HcbsImageComponent } from '../hcbs-image/hcbs-image.component';
import { BrowseTypes, QueryTerms } from 'src/app/shared/models/QueryTerms';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  searchObject: SearchObject;
  plan: MemberPlan;
  loggedIn = false;
  isShop = false;
  isEmployer = false;
  memberID = '';
  count = 0;
  time = 0;
  showLoginForm = true;
  isCaptchaShow = false;
  error: any = {
    memberIdMsg: ''
  };
  public reactiveForm: FormGroup = new FormGroup({
    recaptchaReactive: new FormControl(null, Validators.required)
  });

  @Input() queryParamMap;
  @Input() clickedSearchCriteria;

  constructor(private loginFormService: LoginFormService,
    private searchObjectService: SearchObjectService,
    private userRulesService: UserRulesService,
    private router: Router,
    public _dialog: MatDialog,
    private loadingScreenService: LoadingScreenService) {
      this.plan = new MemberPlan();
      this.plan.planName = '';
      if(localStorage.getItem('isCaptchaShow') === 'true') {
        this.isCaptchaShow = true;
      }
  }

  ngOnInit() {
    let memberCardIdValid: string;
    if(this.queryParamMap) {
      if(this.queryParamMap.get('membercardid')) {
        memberCardIdValid = this.queryParamMap.get('membercardid');
        this.searchObjectService.removeQueryParams('membercardid');
      }
      if(this.queryParamMap.get('memberid')) {
        this.searchObjectService.removeQueryParams('memberid');
      }
    }
    this.loggedIn = this.searchObjectService.isLoggedIn();
    this.time = 0;
    this.count = 0;
    const _searchObject = this.searchObjectService.getSearchObject();
    this.searchObjectService.setSearchObjectQuery({
      params: {
        type: _searchObject.loginType
      }
    });
    this.searchObjectService.tabsData.browseData = new SearchObject();

    if(!this.loggedIn) {
      this.userRulesService.checkLogin(false, memberCardIdValid).subscribe(loggedIn => {
        if(loggedIn) {
          // if token available, get pcp data
          if(this.userRulesService.getIdToken()) {
            const primaryId = this.userRulesService.getPrimaryId();
            this.getMemberDetails(primaryId);
            this.getPCPName(primaryId);
          }
          let memberId = this.userRulesService.getSecondaryId();
          this.memberID = memberId.length > 16 ? memberId.slice(0,memberId.length - 16) : memberId;
          let tpaClientIdentifier  = memberId.length > 16 ? memberId.slice(memberId.length - 16).slice(0,12) : null;
          this.validateLogin(tpaClientIdentifier);
        } else if(this.queryParamMap && this.queryParamMap.params) {
          // marketplace login
          if(this.queryParamMap.params[QueryTerms.type] === BrowseTypes.shop || this.queryParamMap.params[QueryTerms.type] === BrowseTypes.employer) {
            if(this.queryParamMap.params[QueryTerms.network]) {
              this.isShop = (this.queryParamMap.params[QueryTerms.type] === BrowseTypes.shop);
              this.isEmployer = (this.queryParamMap.params[QueryTerms.type] === BrowseTypes.employer);
              this.memberID = this.queryParamMap.params[QueryTerms.network];
            }
            this.validateLogin();
          }
        }
      });
    } else {
        const _loginType = this.searchObjectService.getLoginType();
        this.isShop = (_loginType === BrowseTypes.shop);
        this.isEmployer = (_loginType === BrowseTypes.employer);

    }
  }
  getMemberDetails(memberId: string) {
    this.loginFormService.getMemberDetails(memberId).subscribe(data => {
      this.searchObjectService.setMemberData(data);
    });
  }
  getPCPName(memberId: string) {
    this.error.providerErrorMsg = '';
    this.loginFormService.getPCPName(memberId).subscribe(data => {
      this.searchObjectService.setPcpData(data.currentPcp);
    });
  }

  checkMemberIdCount() {
    const currentTime = new Date().getTime();
    if((this.time === 0 || (currentTime - this.time < 30000))) {
      this.count++;
      this.time = currentTime;
      if(this.count === 3) {
        this.isCaptchaShow = true;
        localStorage.setItem('isCaptchaShow', 'true');
      }
    } else {
      this.count = 0;
      this.time = 0;
      this.isCaptchaShow = false;
      localStorage.removeItem('isCaptchaShow');
    }
  }

  toggleLoginForm() {
    this.loggedIn = !this.loggedIn;
    this.memberID = '';
    this.searchObjectService.setLoggedIn(false, '');
    this.router.navigate(['find']);
  }

  keyDownFunction(event) {
    if(event.keyCode === 13) {
      this.validateLogin();
    }
  }

  validateLogin(tpaClientIdentifier?: string) {
    this.loadingScreenService.toggleLoaderOn();
    this.error.memberIdMsg = '';
    this.error.captchaMsg = '';
    this.loggedIn = false;
    if(this.isCaptchaShow && this.reactiveForm.invalid) {
      this.error.captchaMsg = 'Please make sure you&apos;re not a robot';
    }
    if(!this.memberID.trim()) {
      this.error.memberIdMsg = 'Please enter the Member ID on your insurance card.';
      this.loadingScreenService.toggleLoaderOff();
    } else if(!(this.isShop || this.isEmployer) && !/^[a-zA-Z0-9]{10,11}$/.test(this.memberID.trim())) {
      this.error.memberIdMsg = 'Please enter valid memberid';
      this.checkMemberIdCount();
      this.loadingScreenService.toggleLoaderOff();
    } else {
      this.loginFormService.getMemberNetwork(this.memberID.trim(), tpaClientIdentifier).
        subscribe(data => {
          if(this.isCaptchaShow && this.reactiveForm.invalid && !(this.isShop || this.isEmployer)) {
            this.error.captchaMsg = 'Please make sure you&apos;re not a robot';
          } else if(data === null) {
            this.showMemberError({status : 404});
          } else if(data && data.idMatchError === 'N' && data.networks && data.networks.length !== 0) {
            this.searchObjectService.setLoggedIn(true, (this.isShop ? BrowseTypes.shop : this.isEmployer ? BrowseTypes.employer : ''));
            this.searchObjectService.setCareTypes(data.networks);
            this.loggedIn = true;
            this.showLoginForm = false;
            this.time = 0;
            this.count = 0;
            this.isCaptchaShow = false;
            localStorage.removeItem('isCaptchaShow');
          } else {
            this.error.memberIdMsg = 'We found multiple kinds of coverage associated with your Member ID. Please use the "I&apos;m just Browsing" tab to find the care you need.';
            this.checkMemberIdCount();
          }
          this.loadingScreenService.toggleLoaderOff();
        },
          error => {
            this.showMemberError(error);
          });
    }
  }

  showMemberError(error) {
    this.error.memberIdMsg = (error.status === 404) ? 'We cannot find the ID that you entered, please login to <a class="error-msg-member" target="_blank" href="https://www.upmchealthplan.com/members/">the UPMC Health Plan member site</a> or use the "I&apos;m Just Browsing" tab to find the care you need. ' : 'Error loading values. Please try again.';
    this.checkMemberIdCount();
    this.isShop = false;
    this.isEmployer = false;
    this.loadingScreenService.toggleLoaderOff();
  }

  showhcbsImage() {
    const dialogRef = this._dialog.open(HcbsImageComponent, {
      // height: window.innerHeight -10 +'px'
      // width: (window.innerWidth > 1000 ? 1000 : window.innerWidth - 10) + 'px'
    });
    document.body.style.overflow =  'hidden';
    dialogRef.afterClosed().subscribe(result => {
    document.body.style.overflow =  'auto';
    });
  }

}

class MemberPlan {
  planName: string;

}
